import { Component, Renderer2, AfterViewInit, ElementRef, ViewChild, HostListener, Input, ChangeDetectorRef } from '@angular/core';
import { vp } from './vp.interface';
import { ViewPorts } from './viewports';
import { BrowserWindow } from './window';
declare var $: any;

@Component({
    selector: 'ups-filter',
    template: require('./ups-filter.component.html'),
    providers: [BrowserWindow, ViewPorts]
})

export class UpsFilterComponent implements AfterViewInit {

    globalClick: Function;
    globalKeydown: Function;
    closeFocusElm: HTMLElement;
    toggleMenuShown: boolean = false;
    vpSize: vp;
    focusedItemIndex: number = -1;
    focusableIndexes = [];
    @Input() resize: string = 'lg';
    @ViewChild('toggleDrawerContainer', { static: false }) toggleDrawerContainer: ElementRef;

    constructor(private renderer: Renderer2, private vp: ViewPorts, private cdRef: ChangeDetectorRef, ) {
        vp.viewPortChange().subscribe((val) => {
            this.vpSize = val;
        });

    }

    ngAfterViewInit(): void {
        var tvDrawerContainer = $(this.toggleDrawerContainer.nativeElement).detach();
        $('body').prepend(tvDrawerContainer);
        this.cdRef.detectChanges();
    }

    @HostListener('document:click', ['$event'])
    documentClick(event: any): void {
        this.bodyClicked(event);
    }

    @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        if (event.which && event.which == 27) {
            this.hide();
        } else if (event.keyCode && event.keyCode == 27) {
            this.hide();
        }
    }

    public show(el: HTMLElement): void {
        if (!el) {
            console.error('Error when opening toggle view: Toggle View requires an element to attach to.');
            return;
        }

        if (this.toggleMenuShown) {
            this.hide();
            return;
        }

        this.toggleMenuShown = true;
        this.closeFocusElm = el;
    }

    public hide(): void {
        var wasOpen: boolean = this.toggleMenuShown;
        this.toggleMenuShown = false;

        if (wasOpen) {
            this.closeFocusElm.focus();
        }
    }

    public bodyClicked(e: Event): void {
        if (!this.closeFocusElm) {
            return;
        }
        if (e.target == this.closeFocusElm || $.contains(this.closeFocusElm, e.target)) {
            return;
        }
        this.hide();
    }

    public calculateDrawerTop(): string {
        var focusElTop = $(this.closeFocusElm).offset().top;
        var focusElHeight = $(this.closeFocusElm).outerHeight();
        if (this.resize === 'xs' || this.resize === 'sm') {
            return (focusElTop + focusElHeight).toString() + 'px';
        } else {
            return '263px';
        }
        //return /*(focusElTop + focusElHeight).toString() + 'px';*/
    }

    public calculateDrawerLeft(): string {
        if (this.resize === 'xs' || this.resize === 'sm') {
            return '40px';
        } else {
            return 'auto';
        }
    }

    public calculateDrawerRight(): string {
        var focusElLeft: number = $(this.closeFocusElm).offset().left;
        var focusElWidth: number = $(this.closeFocusElm).outerWidth();
        var windowWidth: number = $(window).width();
        if (this.resize === 'xs' || this.resize === 'sm') {
            return '20px';
        }

        if (focusElLeft > (windowWidth / 2)) {
            return ((windowWidth - focusElLeft) - focusElWidth).toString() + 'px';
        }
    }

    public calculateArrowLeft(): string {
        if (this.resize === 'xs' || this.resize === 'sm') {
            return '43px';
        }
        return 'auto';
    }

    public calculateArrowRight(): string {
        if (this.resize === 'xs' || this.resize === 'sm') {
            return 'auto';
        }
        return '3px';
    }

    toggleDrawerContainerClick(e: Event) {
        e.stopPropagation();
    }

}